export enum DirectionalJetlag {
  HARD_GOING_THERE = 'difficult-arriving',
  HARD_COMING_BACK = 'difficult-returning',
  EQUALLY_HARD = 'difficult-equally',
}
